(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cheapmini-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.querySelector('[data-cheapmini-newsletter-popup]');
    if (!popup) {
      return;
    }

    var key = 'cheapminiNewsletterPopupClosedAt';
    var couponKey = 'cheapminiNewsletterPopupCoupon';
    var expiry = 7 * 24 * 60 * 60 * 1000;
    var panel = popup.querySelector('.cheapmini-newsletter-popup__panel');
    var forced = popup.querySelector('.errors') || popup.querySelector('[role="status"]');

    function getClosedAt() {
      try {
        return Number(window.localStorage.getItem(key)) || 0;
      } catch (error) {
        return 0;
      }
    }

    function setClosedAt() {
      try {
        window.localStorage.setItem(key, String(Date.now()));
      } catch (error) {
        return;
      }
    }

    function parseCoupons(coupon) {
      var raw = coupon.getAttribute('data-coupons') || '';
      return raw.split('|').map(function (item) {
        var parts = item.split('::');
        return {
          code: parts[0],
          label: parts[1]
        };
      }).filter(function (item) {
        return item.code && item.label;
      });
    }

    function readStoredCoupon() {
      try {
        return JSON.parse(window.localStorage.getItem(couponKey) || 'null');
      } catch (error) {
        return null;
      }
    }

    function storeCoupon(coupon) {
      try {
        window.localStorage.setItem(couponKey, JSON.stringify(coupon));
      } catch (error) {
        return;
      }
    }

    function chooseCoupon() {
      var coupon = popup.querySelector('[data-cheapmini-popup-coupon]');
      if (!coupon) {
        return;
      }

      var choices = parseCoupons(coupon);
      if (!choices.length) {
        return;
      }

      var selected = readStoredCoupon();
      if (!selected || !selected.code || !selected.label) {
        selected = choices[Math.floor(Math.random() * choices.length)];
        storeCoupon(selected);
      }

      var code = coupon.querySelector('[data-cheapmini-coupon-code]');
      var value = coupon.querySelector('[data-cheapmini-coupon-value]');
      var copy = coupon.querySelector('[data-cheapmini-coupon-copy]');
      var shop = coupon.querySelector('[data-cheapmini-coupon-shop]');

      if (code) {
        code.textContent = selected.code;
      }

      if (value) {
        value.textContent = selected.label;
      }

      if (shop) {
        shop.setAttribute('href', '/discount/' + encodeURIComponent(selected.code) + '?redirect=/collections/all');
      }

      if (copy) {
        copy.addEventListener('click', function () {
          var original = copy.getAttribute('data-copy-label') || copy.textContent;
          var copied = copy.getAttribute('data-copied-label') || original;

          function showCopied() {
            copy.textContent = copied;
            window.setTimeout(function () {
              copy.textContent = original;
            }, 1600);
          }

          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(selected.code).then(showCopied);
            return;
          }

          var field = document.createElement('textarea');
          field.value = selected.code;
          field.setAttribute('readonly', 'readonly');
          field.style.position = 'absolute';
          field.style.left = '-9999px';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          document.body.removeChild(field);
          showCopied();
        });
      }
    }

    function openPopup() {
      popup.hidden = false;
      window.setTimeout(function () {
        if (panel) {
          panel.focus();
        }
      }, 50);
    }

    function closePopup() {
      popup.hidden = true;
      setClosedAt();
    }

    chooseCoupon();

    Array.prototype.slice.call(popup.querySelectorAll('[data-cheapmini-newsletter-popup-close]')).forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.hidden && event.key === 'Escape') {
        closePopup();
      }
    });

    if (forced) {
      openPopup();
      return;
    }

    if (getClosedAt() && Date.now() - getClosedAt() < expiry) {
      return;
    }

    window.setTimeout(openPopup, 3500);
  })();
  } catch(e) { console.error(e); }
})();

})();
